/**
 * @description The method creates an instance of the module to be mounted
 * @param {Function} callback a callback that accepts the mounted code
 */
export function showcaseStatus(): 'connected' | 'private' {
  return (window as any).showcase_connected;
}
